export default class Faturamento {

    constructor(resource) {
        this._resource = resource('Faturamento_supo');
    }

    getBoletos(rdata) {
        console.log(this._resource);
        return this._resource
            .save({}, rdata)
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    geraFaturamento(rdata) {
        return this._resource
            .update({}, rdata)
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    getFaturamento(codbco, referencia) {
        return this._resource
            .get(
                {
                    codbco: codbco,
                    referencia: referencia
                })
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    getMemoria(cod_contrato, referencia, id_cliente) {
        return this._resource
            .get(
                {
                    cod_contrato: cod_contrato,
                    referencia: referencia,
                    id_cliente: id_cliente
                })
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    getLog(referencia) {
        return this._resource
            .get(
                {
                    referencia: referencia,
                })
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    enviaEmail(assunto, corpo, referencia) {
        return this._resource
            .update({ assunto: assunto, corpo: corpo, referencia: referencia },[])
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }
    
    impBoleto(codbco, referencia, data_venc, cod_contrato) {

        return this._resource
            .get(
                {
                    codbco: codbco,
                    referencia: referencia,
                    data_venc: data_venc,
                    cod_contrato: cod_contrato
                })
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    delete(id, cod_contrato, referencia) {
        return this._resource
            .delete({ id: id, cod_contrato: cod_contrato, referencia: referencia })
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }
}